import { useState } from "react";
import croonusLogo from "../../assets/images/logo/croonus-logo-menu-white.png";
import useAPI from "../../hooks/useAPI";
import CreateForm from "components/Form/CreateForm/CreateForm";
import Sitemap from "routes/sitemap";
import Loading from "components/Loading/Loading";
import scss from "./RegistrationPage.module.scss";
// import formFields from "./formFields.json";
import { useTranslation } from "react-i18next";
import { printError } from "../../helpers/apiError";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
/**
 * The login page for the B2B.
 *
 * @return {JSX.Element}
 * @constructor
 */

function generateEmptyObject(array) {
    return array.reduce((acc, item) => {
        acc[item.key] = null;
        return acc;
    }, {});
}

const RegistrationPage = () => {
    const { t } = useTranslation();

    const api = useAPI();

    const [data, setData] = useState({});
    const [message, setMessage] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);

    const [fieldsError, setFieldsError] = useState(null);

    const { data: registrationFields } = useQuery(["registrationFields"], () => api.get(`/customer/registration-fields`));

    const submitHandler = () => {
        setIsLoading(true);
        const init = generateEmptyObject(registrationFields);

        api.post("customer/registration", { ...init, ...data })
            .then((response) => {
                setMessage(response?.message ? response.message : t("registration-default-form-message-success_registration"));
                setIsLoading(false);
                setIsSent(true);
            })
            .catch((error) => {
                setIsLoading(false);

                setFieldsError(error?.response?.data?.payload?.fields);
                if (error?.response?.data?.payload?.fields) return;

                toast.error(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };

    let formFields;
    if (registrationFields) {
        formFields = registrationFields.map((field) => {
            const note = field.key.startsWith("note");
            const typeString = field.fields_rule.includes("string");

            return {
                columns: true,
                disabled: false,
                field: field.key,
                label: `registration-default-form-field-${field.key}-label`,
                placeholder: "",
                required: field.fields_rule.includes("required"),
                rows: note ? 3 : false,
                type: note ? "textarea" : typeString ? "text" : "number",
            };
        });
    }

    return (
        <div className={scss["login-container"]}>
            <div className={scss["login-card"]}>
                <div className={scss["background-wrapper"]}>
                    <img src={api.buildPath("/configuration/images/presentation/login/image")} alt="" />
                    <div />
                </div>
                <div className={`${scss["login-card-gray-overlay"]} col-xxl-6 col-lg-8 `}>
                    {/* Background image */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                        className={scss.logoHolder}
                    >
                        <img
                            src={api.buildPath("/configuration/images/presentation/login/logo")}
                            className={scss["logo"]}
                            alt="logo"
                            style={{
                                position: "relative",
                            }}
                        />
                        <p
                            className={scss.logoText}
                            style={{
                                color: "white",
                                fontSize: "1.5rem",
                                position: "relative",
                                fontWeight: "bolder",
                                textAlign: "left",
                                //tight fit
                                lineHeight: "0.85",
                                marginTop: "1rem",
                                marginLeft: "2.5rem",
                            }}
                        >
                            B2B
                            <br /> PORTAL
                        </p>
                    </div>

                    {/* Title, subtitle and description */}
                    <h1 className={scss["company-title"]}>
                        {t("registration-default-text-become_user")}
                        {/*<span className={scss["big-dot"]}>.</span>*/}
                    </h1>
                    <h5 className={scss["login-sub-title"]}>{t("registration-default-text-info")} </h5>
                    <h5 className={scss["login-sub-title"]}>
                        {t("registration-default-text-already_have_account")} <a href={Sitemap.auth.login}>{t("registration-default-text-login")}</a>
                    </h5>
                    {!isLoading ? (
                        <>
                            {message && (
                                <div className={scss.message}>
                                    <p>{message}</p>
                                </div>
                            )}
                            {!isSent && formFields && (
                                <div className={" login-form-style"}>
                                    <CreateForm
                                        fieldsError={fieldsError}
                                        data={data}
                                        setData={setData}
                                        formFields={formFields}
                                        className={scss.form}
                                        submit={{ label: "registration-default-form-button-submit", action: submitHandler }}
                                        formButtons={true}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <Loading size={50} />
                    )}

                    {/* Copyright */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            alignItems: "start",
                            marginRight: "auto",
                        }}
                        className={scss["powered"] + " col-xxl-4 col-lg-6"}
                    >
                        <p className={scss["paragraph"]}>{t("login-default-text-powered_by")}: </p>
                        <a href="https://croonus.com/" target="_blank" rel="noopener noreferrer">
                            <img src={croonusLogo} width={150} alt="Croonus logo" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationPage;
